import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../utils/components/Breadcrumbs";
import Button from "../../../utils/components/Button";
import SpecificAlert from "../../../utils/components/SpecificAlert/SpecificAlert";
import Modal from "../../../utils/components/Modal";
import { Link } from "react-router-dom";
import keepOrganizer from "../../../utils/functions/keepOrganizer";
import LoadingOverlay from "../../../utils/components/LoadingOverlay";

const IntegrationsForm = ({
    saveIntegrations,
    hideSpecificAlert,
    panelTitle,
    loadingSave,
    loadingLoad,
    organizer,
    setOrganizerKeyValue,
    showSyncModal,
    setShowSyncModal,
    allTournaments,
    selectedTournaments,
    setSelectedTournaments,
    onSync,
    loadingSync,
    lineupsByTournament,
    revaLineups,
    revaConnectionError
}) => {
    const [expandedYears, setExpandedYears] = useState({});

    useEffect(() => {
        hideSpecificAlert();
    }, []);

    const toggleYear = (year) => {
        setExpandedYears(prev => ({
            ...prev,
            [year]: !prev[year]
        }));
    };

    const getTournamentSyncStatus = (tournamentId) => {
        const tournamentLineups = lineupsByTournament[tournamentId] || [];
        const totalCount = tournamentLineups.length;
        if (!lineupsByTournament[tournamentId] || totalCount === 0) return { isFullySynced: false, totalCount: 0, syncedCount: 0 };

        const syncedCount = tournamentLineups.filter(lineup =>
            (revaLineups || []).some(rt => rt.external_entity_id === lineup.id)
        ).length;

        return {
            isFullySynced: syncedCount === totalCount,
            isPartiallySynced: syncedCount > 0 && syncedCount < totalCount,
            totalCount,
            syncedCount
        };
    };

    const handleSelectAllYear = (year, checked) => {
        const yearTournaments = tournamentsByYear[year]
            .filter(t => !getTournamentSyncStatus(t.id).isFullySynced)
            .map(t => t.id);

        if (checked) {
            const newSelected = [...new Set([...selectedTournaments, ...yearTournaments])];
            setSelectedTournaments(newSelected);
        } else {
            const newSelected = selectedTournaments.filter(id => !yearTournaments.includes(id));
            setSelectedTournaments(newSelected);
        }
    };

    const isYearFullySelected = (year) => {
        const yearTournaments = tournamentsByYear[year]
            .filter(t => !getTournamentSyncStatus(t.id).isFullySynced)
            .map(t => t.id);

        if (yearTournaments.length === 0) return true; // Everything already synced
        return yearTournaments.every(id => selectedTournaments.includes(id));
    };

    const toggleTournament = (id) => {
        if (selectedTournaments.includes(id)) {
            setSelectedTournaments(selectedTournaments.filter(tId => tId !== id));
        } else {
            setSelectedTournaments([...selectedTournaments, id]);
        }
    };

    const tournamentsByYear = (allTournaments || []).reduce((acc, t) => {
        const year = t.year || "Otros";
        if (!acc[year]) acc[year] = [];
        acc[year].push(t);
        return acc;
    }, {});

    const sortedYears = Object.keys(tournamentsByYear).sort((a, b) => b - a);

    const totalTeamsToSync = allTournaments
        .filter(t => selectedTournaments.includes(t.id))
        .reduce((sum, t) => sum + (lineupsByTournament[t.id] || []).length, 0);

    const modalBody = () => (
        <div>
            <div className="alert alert-success">
                <i className="fa fa-check-circle"></i> ¡API Key validada con éxito!
            </div>
            <p>Se ha detectado una nueva API Key de Reva. ¿Deseas sincronizar las <b>participaciones (Lineups)</b> de tus equipos en cada torneo?</p>

            <div className="m-t-md" style={{ maxHeight: '450px', overflowY: 'auto', paddingRight: '10px' }}>
                <label>Selecciona los torneos a sincronizar:</label>
                {sortedYears.map(year => (
                    <div key={year} className="year-group m-b-sm border-left border-right border-top border-bottom">
                        <div
                            className="year-header p-xs border-bottom pointer flex-container"
                            style={{ backgroundColor: '#f3f3f4', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <div className="flex-item" onClick={() => toggleYear(year)} style={{ flex: 1, cursor: 'pointer', fontWeight: 'bold' }}>
                                <i className={`fa fa-chevron-${expandedYears[year] ? 'down' : 'right'} m-r-xs`}></i>
                                Año {year}
                                <span className="m-l-sm label label-info">{tournamentsByYear[year].length} torneos</span>
                            </div>
                            <div className="checkbox checkbox-primary no-margins p-r-xs">
                                <input
                                    id={`all-${year}`}
                                    type="checkbox"
                                    checked={isYearFullySelected(year)}
                                    onChange={(e) => handleSelectAllYear(year, e.target.checked)}
                                />
                                <label htmlFor={`all-${year}`} className="p-l-xs">Seleccionar todo</label>
                            </div>
                        </div>

                        {expandedYears[year] && (
                            <div className="list-group no-margins">
                                {tournamentsByYear[year].map(tournament => {
                                    const { isFullySynced, isPartiallySynced, totalCount, syncedCount } = getTournamentSyncStatus(tournament.id);
                                    const isLoading = !lineupsByTournament[tournament.id];

                                    return (
                                        <div
                                            key={tournament.id}
                                            className="list-group-item"
                                            style={{
                                                paddingLeft: '30px',
                                                opacity: isFullySynced ? 0.6 : 1,
                                                backgroundColor: isFullySynced ? '#f9f9f9' : 'transparent'
                                            }}
                                        >
                                            <div className="checkbox checkbox-primary no-margins">
                                                <input
                                                    id={`tour-${tournament.id}`}
                                                    type="checkbox"
                                                    checked={selectedTournaments.includes(tournament.id) || isFullySynced}
                                                    onChange={() => !isFullySynced && toggleTournament(tournament.id)}
                                                    disabled={isLoading || isFullySynced}
                                                />
                                                <label htmlFor={`tour-${tournament.id}`} style={{ color: isFullySynced ? '#999' : 'inherit' }}>
                                                    {tournament.name}
                                                    <span className="pull-right">
                                                        {isFullySynced ? (
                                                            <span className="label label-primary m-r-xs">Sincronizado</span>
                                                        ) : isPartiallySynced ? (
                                                            <span className="label label-warning m-r-xs">Parcial ({syncedCount}/{totalCount})</span>
                                                        ) : null}

                                                        <span className="label label-default">
                                                            {isLoading ? <i className="fa fa-spinner fa-spin"></i> : `${totalCount} equipos`}
                                                        </span>
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className="text-center m-t-lg">
                <h4>Total equipos a sincronizar: <strong>{totalTeamsToSync}</strong></h4>
            </div>
        </div>
    );

    return (
        <>
            <Breadcrumbs
                title="Integraciones"
                opts={[
                    {
                        title: "Inicio",
                        path: "/",
                    },
                    {
                        title: "Integraciones",
                        active: true,
                    },
                ]}
                rightHeader={
                    <Button
                        className="btn btn-primary"
                        title="Gestionar Plantillas de Cobro"
                        disabled={revaConnectionError}
                        onClick={() => {
                            if (!revaConnectionError) {
                                window.location.href = keepOrganizer("/financial/prices");
                            }
                        }}
                    />
                }
            />
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox m-t">
                        <div className="ibox-content">
                            <SpecificAlert />
                            <LoadingOverlay loading={loadingLoad}>

                            {revaConnectionError && (
                                <div className="alert alert-danger" style={{ display: 'flex', alignItems: 'center' }}>
                                    <i className="fa fa-exclamation-triangle fa-2x m-r-md"></i>
                                    <div>
                                        <strong>Error de Conexión:</strong> La API Key de Reva parece ser inválida o ha expirado.
                                        Por favor, verifica la clave introducida. Algunas funciones financieras estarán deshabilitadas hasta que se resuelva.
                                    </div>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="panel panel-default">
                                        <div className="panel-heading">{panelTitle}</div>
                                        <div className="panel-body">
                                            <div className="form-group">
                                                <label className="control-label">Reva API KEY</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={organizer.revaApiKey || ""}
                                                    onChange={(e) => setOrganizerKeyValue("revaApiKey", e.target.value)}
                                                    placeholder="Introduce la API Key de Reva"
                                                    disabled={loadingLoad}
                                                />
                                            </div>

                                            {organizer.revaApiKey && (
                                                <div className="m-t-md">
                                                    <Button
                                                        className={`btn btn-default btn-outline btn-xs ${revaConnectionError ? 'disabled' : ''}`}
                                                        title={<><i className="fa fa-refresh"></i> Ir al Panel de Sincronización</>}
                                                        disabled={revaConnectionError}
                                                        onClick={() => {
                                                            if (!revaConnectionError) {
                                                                window.location.href = keepOrganizer("/reva-sync");
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <Button
                                        className="btn btn-primary pull-right"
                                        title="Guardar"
                                        loading={loadingSave}
                                        onClick={saveIntegrations}
                                    />
                                </div>
                            </div>
                            </LoadingOverlay>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={showSyncModal}
                handleShow={setShowSyncModal}
                title="Sincronización Automática"
                body={modalBody()}
                backdrop="static"
                buttons={[
                    <Button
                        key="cancel"
                        className="btn btn-white"
                        title="Ahora No"
                        onClick={() => setShowSyncModal(false)}
                    />,
                    <Button
                        key="sync"
                        className="btn btn-primary"
                        title="Sincronizar"
                        onClick={onSync}
                        loading={loadingSync}
                        disabled={selectedTournaments.length === 0}
                    />
                ]}
            />
        </>
    );
};

export default IntegrationsForm;
